





























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
})
export default class ProductTags extends Vue {
  @Prop({ type: Array })
  filters!: Array<Filter>

  @Prop({ type: String })
  searchQuery!: string

  private setFilterInactive (filter: FilterOption) {
    Vue.set(filter, 'Active', !filter.Active)
    this.$emit('filter')
  }

  private clearRangeFilter (filter: FilterOption) {
    if (filter.RangeValue.length > 1) {
      Vue.set(filter, 'RangeValue', filter.Range)
    } else {
      Vue.set(filter, 'RangeValue', filter.Range[0])
    }
    this.$emit('filter')
  }

  private clearSearch () {
    this.$emit('clearSearch')
  }

  get selectedFilterCount () {
    let count = 0

    this.filters.forEach((filters) => {
      filters.Options.forEach((filter) => {
        if (filter.Active) {
          count++
        }
      })
    })

    return count
  }
}
